enum EDividerColor {
    White = "white",
    DarkBlue = "darkBlue",
    SemiDarkBlue = "semiDarkBlue",
    MediumBlue = "mediumBlue",
    LightBlue = "lightBlue"
}

export { EDividerColor }
